<template lang="pug">
	section#inscricao
		.informacoes
			ul.informacoesGerais
				li
					strong Tipo:
					span {{ curso.tipo ? $utils.getTipoCurso(curso.tipo) : '' }}
				li
					strong Duração:
					span {{ curso.duracao }}
				li(v-if="curso.preco && curso.tipo == 'EXT'")
					strong Matrícula:
					span A partir de R$ {{ curso.preco[0] }},{{ curso.preco[1] }}
				li(v-if="curso.tipo != 'GRAD' && curso.tipo != 'EXT'")
					strong Matrícula:
					span {{ curso.valor_matricula.toString() }}

			.saude(v-if="(curso.preco && (curso.tipo == 'GRAD' || curso.tipo == 'EXT')) && curso.is_saude")
				small
					| Os dados gerais de curso apresentados acima, são do curso de
					| {{curso.nome_curso}}. Para Saber mais sobre os cursos novos de Saúde,
					| consulte seu polo ou ligue 0800 642 6002.

			button.informacoesLegais(type="button", @click="toggleInformacoesLegais", title="Informações Legais") Informações Legais

			.mensalidades
				.graduacao(v-if="curso.preco && (curso.tipo == 'GRAD' || curso.tipo == 'EXT')")
					p(v-if="curso.tipo == 'GRAD'").lower_case
						| Valor das Mensalidades:
					p.preco_antigo Antes:
						br
						| {{curso.old_mensalidade}} Mensalidades de R$ {{curso.preco_bruto}}
					p.black_strong AGORA É:
					p 1 + {{ curso.num_mensalidade }} Mensalidades
					p A partir de R$ {{ curso.preco[0] }},{{ curso.preco[1] }}*
					p
						span(v-if="curso.curso_id == '249' || curso.curso_id == '240'").aviso_legal Aprenda muito e pague pouco!
						span(v-else).aviso_legal Seu curso Agora em Menos Tempo e Muito mais Barato.
					.campanha
						p
							| Vá ao polo mais próximo e consulte as bolsas de desconto disponíveis para os cursos de Graduação,
							| como a do preço acima.
							strong  Corra, as bolsas por polo são limitadas e os benefícios condicionados ao pagamento da primeira mensalidade no ato da matrícula.
						small(v-if="showCampanhaGradSmall")
							| ¹Saiba mais sobre a campanha CashBack e valor por dia em:
							router-link(:to="{ path: '/politica-de-precos' }")  fael.edu.br/politicadeprecos
				.pos-graduacao(v-if="curso.tipo == 'POS' && curso.mensalidade_liquida.length")
					.valores
						p.gray_text
							strong  VALOR TOTAL DO CURSO*
						p.red_text
							| De: R$ {{getTotalPos(curso.preco)}}
						p
							strong Por a Partir de:
							|  R$ {{curso.preco_total}}
							br
							| *Valores à vista
					ul
						li(v-for="mensalidade in curso.mensalidade_liquida") {{ mensalidade }}
					.campanha
						p(v-if="this.curso.curso_id !== '986'" )
							strong APROVEITE:
							| 18 PARCELAS DE até R$ {{this.curso.preco}}#[sup 1] com Cupom de Desconto.
						p(v-else)
							strong APROVEITE:
							| 18 PARCELAS DE até R$ {{this.curso.preco}}#[sup 1] com preço promocional especial.
							|  #[sup 1]Consulte Investimento e as demais possibilidades de parcelamento.
						p(v-if="this.curso.curso_id !== '986'")
							| Consulte seu polo para disponibilidade ou ligue agora mesmo:
							a(href="tel:08006426002") 0800 642 6002


				.pos-graduacao(v-if="curso.tipo == 'ENSMED' && curso.mensalidade_liquida.length")
					ul
						li(v-for="mensalidade in curso.mensalidade_liquida") {{ mensalidade }}
					.campanha()
						p
							| Vá ao polo mais próximo e consulte as bolsas de desconto disponíveis para o seu curso Técnico com mensalidades a partir de R$ 89,00¹.
							strong  Corra, as bolsas por polo são limitadas!
						small(v-if="showCampanhaGradSmall")
							| ¹Saiba mais sobre a campanha CashBack e valor por dia em:
							router-link(:to="{ path: '/politica-de-precos' }")  fael.edu.br/politicadeprecos

			form.formulario(@submit.prevent="sendInscricao(true)")
				.input(:class="{ error: errors.nome }")
					input(name="input_nome_inscricao", id="input_nome_inscricao", type="text", placeholder="Nome", v-model="formulario.nome")
					span.error(v-if="errors.nome") {{ errors.nome[0] }}
				.input(:class="{ error: errors.email }")
					input(name="input_email_inscricao", id="input_email_inscricao", type="email", placeholder="E-mail", v-model="formulario.email")
					span.error(v-if="errors.email") {{ errors.email[0] }}
				.input(:class="{ error: errors.celular }")
					input(name="input.celular_inscricao", id="input.celular_inscricao", type="tel", placeholder="Celular", v-model="formulario.celular", v-mask="'(##) #####-####'")
					span.error(v-if="errors.celular") {{ errors.celular[0] }}
				.check
					label(for="input_contato_whatsapp_inscricao")
						span Podemos usar o WhatsApp e/ou SMS para falar sobre sua inscrição, matrícula e prestação de serviços?
						input(name="input_contato_whatsapp_inscricao", id="input_contato_whatsapp_inscricao", type="checkbox", v-model="formulario.contato_whatsapp")
						| Autorizo o uso do WhatsApp e/ou SMS no telefone informado.
				.button
					button(type="submit", :disabled="disabled", v-html="btnEnviar")
				.button._50
					button(type="button", :disabled="disabled", @click="loginFacebook").facebook
						include ../../../assets/svgs/icones/icone-facebook.svg
				.button._50
					button(type="button", :disabled="disabled", @click="loginGoogle").google
						include ../../../assets/svgs/icones/icone-google.svg

		Aside(:ativo="informacoesLegais", @close="informacoesLegais = false").asideInformacoesLegais
			p(v-html="curso.descricao")
</template>

<script>
	import {mask} from 'vue-the-mask'

	import Aside from '@components/Aside/Aside'
	import {CURSOS_EDUCACAO_GRAD, CURSOS_TRANSFERENCIAS} from '@views/Curso/Constantes'

	const GOOGLE_API_ID = 'google-api-auth2'
	const FACEBOOK_API_ID = 'facebook-jssdk'

	export default {
		name: "section-inscricao",
		props: {
			curso: Object
		},
		components: {
			Aside
		},
		directives: {
			mask
		},
		data() {
			return {
				informacoesLegais: false,
				precoPos:'',
				formulario: {
					nome: '',
					email: '',
					celular: '',
					contato_whatsapp: false,
					origem: localStorage.getItem("referrer"),
					form_origem: 'form-curso',
					has_celular: false,
					gclid: localStorage.getItem("gclid") || '',
				},
				errors: {},
				btnEnviar: 'Inscreva-se',
				disabled: false,
				authGoogle: {}
			}
		},
		computed: {
			showCampanhaGradSmall() {
				return !this.isCursoSaoLucas
			},
			isCursoSaoLucas() {
				return CURSOS_EDUCACAO_GRAD.includes(this.curso.curso_id)
			},
		},
		created() {
			this.initGoogleApi();
			this.initFacebookApi();
			if (localStorage.getItem('v6') !== null) {
				this.formulario.v6 = localStorage.getItem('v6');
				localStorage.removeItem('v6');
			}
			if (localStorage.getItem('v10') !== null) {
				this.formulario.v10 = localStorage.getItem('v10');
				localStorage.removeItem('v10');
			}
		},
		methods: {
			showCampanhaPos() {
				if (this.curso){
					if(this.curso.preco == '99,00'){
						this.precoPos = '64,35';
						return true;
					}
					if(this.curso.preco == '149,24'){
						this.precoPos = '97,00';
						return true;
					}
					return false;
				}

				return false
			},
			toggleInformacoesLegais() {
				this.informacoesLegais = !this.informacoesLegais
			},
			sendInscricao(has_celular = false) {
				const salesForceMetaName = this.isCursoSaoLucas ? 'sales_force_saolucas_url' : 'sales_force_url'
				this.errors = {}
				this.disabled = true
				this.btnEnviar = 'Enviando...'
				this.formulario.has_celular = has_celular

				if (!this.formulario.facebook_id && !this.formulario.google_id)
					this.setSocialFormulario()

				this.$leads.send('save-lead', this.formulario, null, null, salesForceMetaName)
				.then(() => this.btnEnviar = 'Enviado!')
				.catch(error => {
					if (error.status == 422)
						this.errors = error.error_validate
					this.disabled = false
					this.btnEnviar = 'Inscreva-se'
				})
			},
			loginFacebook() {
				const scope = 'public_profile,email'
				const fields = 'id,email,name'

				// eslint-disable-next-line
				FB.login(response => {
					if (response.status == 'connected') {
						// eslint-disable-next-line
						FB.api('/me', {fields}, response => {
							this.setSocialFormulario({
								nome: response.name,
								email: response.email,
								facebook_id: response.id,
							})
							this.setDataLayer()
							this.sendInscricao()
						})
					} else if (response.status === 'not_authorized') {
						// TODO Não dado permissão.
						console.warn("loginFacebook() - Não permitido");
					} else {
						// TODO não conectado.
						console.warn("loginFacebook() - Não conectado");
					}
				}, {scope})
			},
			loginGoogle() {
				this.authGoogle
				.signIn()
				.then(googleUser => {
					if (googleUser) {
						let profile = googleUser.getBasicProfile();
						this.setSocialFormulario({
							nome: profile.getName(),
							email: profile.getEmail(),
							google_id: profile.getId(),
						})
						this.setDataLayer()
						this.sendInscricao()
					}
				})
				.catch(error => console.warn(`loginGoogle() - ${error.error}`))
			},
			setSocialFormulario(values = {}) {
				const CURSO_INFO = {
					curso_tipo: CURSOS_TRANSFERENCIAS.includes(this.curso.curso_id) ? 'TA' : this.curso.tipo,
					curso_id: this.curso.curso_id,
					curso_nome: this.curso.nome_curso,
					canal_vendas: CURSOS_TRANSFERENCIAS.includes(this.curso.curso_id) ? this.$utils.getTipoCurso('ta') : this.$utils.getTipoCurso(this.curso.tipo)
				}
				this.formulario = Object.assign({}, this.formulario, CURSO_INFO, values)
			},
			setDataLayer() {
				// eslint-disable-next-line
				if (!dataLayer)
					return

				// eslint-disable-next-line
				fbq('track', 'CompleteRegistration');
				// eslint-disable-next-line
				dataLayer.push({
					event: 'crto_productpage',
					crto: {
						email: this.formulario.email, // e-mail pode ser vazio se ainda não tiver essa informação
						products: this.curso.slug
					}
				})
				let tm_event = false
				if (this.curso.tipo === "GRAD")
					tm_event = 'P1-graduacao-' + this.curso.slug.replace(/-/g, '')
				else if (this.curso.tipo === "POS")
					tm_event = 'P1-pos-' + this.curso.slug.replace(/-/g, '')

				if (tm_event) {
					// eslint-disable-next-line
					dataLayer.push({
						Botoes: 'CTA',
						Inscricao: 'inscreva',
						event: tm_event
					})
				}
			},
			initGoogleApi() {
				if (document.getElementById(GOOGLE_API_ID))
					return
				let script = document.createElement('script')
				script.src = "https://apis.google.com/js/platform.js"
				script.id = GOOGLE_API_ID
				script.onload = () => {
					// eslint-disable-next-line
					gapi.load('auth2', () => {
						// eslint-disable-next-line
						this.authGoogle = gapi.auth2.init({
							client_id: '83941582628-komn5a8i1at3t4l75jakq3lkmlfsdr2t.apps.googleusercontent.com',
							scope: 'profile'
						})
					})
				}
				document.querySelector('head').append(script);
			},
			initFacebookApi() {
				if (document.getElementById(FACEBOOK_API_ID))
					return
				let script = document.createElement('script')
				script.src = "https://connect.facebook.net/en_US/sdk.js"
				script.id = FACEBOOK_API_ID
				script.onload = () => {
					// eslint-disable-next-line
					FB.init({
						appId: '1289138364619974',
						autoLogAppEvents: true,
						xfbml: true,
						version: 'v3.2'
					})
				}
				document.querySelector('head').append(script);
			},
			getTotalPos(valor){
				if(valor == '64,35')
					return '2.509,86';
				else{
					if(this.curso.curso_id == '986')
						return "5.000,00"
					return '3.782,93';
				}

			}
		},
	}
</script>

<style lang="stylus" scoped src="./Inscricao.styl"></style>
